export default "__VITE_ASSET__NmRdQBti__"